import { useLang } from '@/i18n';
import EcoPicture from 'eco-design/base/eco-picture';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

const C: React.FC = () => {
    const { t } = useLang('aboutus.C');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer?.create({
                triggerElement: `.${css.section}`,
                triggerHook: 0.8,
                onEnter: () => setEnter(true),
            });

            return () => scene?.destroy();
        }
    }, []);

    return (
        <div id="about-US-C" className={`about-US-C ${css.section}  GtmModuleData-section`} data-section-id={'about-US-C'}>
            <div className="img-bg">
                <EcoPicture
                    jpg={[
                        'https://websiteoss.ecoflow.com/figma-uploads/1767768183843-2h8u5k-compressed-Frame%202094654946.jpg',
                        'https://websiteoss.ecoflow.com/figma-uploads/1767768202729-aoof4j-compressed-Frame%202094654988.jpg',
                    ]}
                    alt={t('title')}
                />
            </div>
            <div className={`info ${enter ? 'enter' : ''}`}>
                <h2 className="title">{t('title')}</h2>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="content">
                <div className={`brands ${enter ? 'enter' : ''}`}>
                    <EcoPicture
                        jpg={[
                            'https://websiteoss.ecoflow.com/figma-uploads/1768464822155-3eazkq-compressed-%E7%94%9F%E6%80%81%E5%88%87%E5%9B%BE1.6.png',
                            'https://websiteoss.ecoflow.com/figma-uploads/1768464868735-vhagz7-compressed-%E7%94%9F%E6%80%81%E5%88%87%E5%9B%BE1.6.png',
                        ]}
                        alt={t('name')}
                    />
                </div>
                <div className={`msg ${enter ? 'enter' : ''}`}>
                    <h3 className="title">{t('name')}</h3>
                    <p className="desc">{t('text')}</p>
                </div>
            </div>
        </div>
    );
};

export default C;
